export const config = {
  title: 'Tag to Job',
  okText: 'Tag',
  width: 480,
  disabledUntilFilled: true,
  fields: [
    {
      name: 'jobId',
      label: 'Job Title / ID',
      type: 'search-select',
      required: true,
      placeholder: 'Minimum 3 characters',
      searchFetchKey: 'tagToJobJobList',
      valueKey: '_id',
      labelTemplate: '{jobReferenceId} - {jobTitle}',
    },
    {
      name: 'hiringStage',
      label: 'Hiring stage',
      type: 'select',
      required: true,
      // Options are fetched live from the hiring-pipeline workflow config
      // (see tag-to-job/api.js's getOptions) — never hardcoded, so an admin
      // renaming or adding a stage is reflected here with no code change.
      fetchOptionsKey: 'hiringStages',
    },
  ],
};
